<template>
  <tr>
    <td class="nowrap drag_handle"><i class="fa fa-align-justify"></i></td>
    <td class="nowrap">{{ location.location_name }}</td>
    <td class="nowrap">
      <span v-if="location.pref"
        >{{ this.options.pref[location.pref] }}</span
      >
      <span v-if="location.address"
        >{{ location.address }}</span
      >
      <span v-if="location.tel"><br />TEL. {{ location.tel }}</span
      ><span v-if="location.tel && location.fax">&emsp;/&emsp;</span>
      <span v-if="location.fax">FAX. {{ location.fax }}</span>
    </td>
    <td class="txt--nowrap">{{ mapTypeName(location.map_type) }}</td>
    <td class="txt--nowrap">{{ statusName(location.location_status) }}</td>
    <td class="nowrap list_control">
      <button
        class="btn btn-primary btn-xs"
        type="button"
        @click="
          emitChangeEvent(
            location_index,
            '#dialog_location_change_' + location_index
          )
        "
      >
        <i class="fa fa-edit"></i>変更
      </button>
      <button
        class="btn btn-primary btn-xs"
        type="button"
        @click="
          emitDeleteEvent(
            location_index,
            '#dialog_location_delete_' + location_index
          )
        "
      >
        <i class="fa fa-trash"></i> 削除
      </button>
    </td>
    <div
      class="modal fade inmodal"
      role="dialog"
      :id="'dialog_location_change_' + location_index"
      tabindex="-1"
    >
      <app-location-change
        :options="options"
        :location="location"
        :location_index="location_index"
        @change="$listeners['change']"
        @change-cancel="$listeners['change-cancel']"
      >
      </app-location-change>
    </div>
    <div
      class="modal fade inmodal"
      role="dialog"
      :id="'dialog_location_delete_' + location_index"
      tabindex="-1"
    >
      <app-location-delete
        :location="location"
        :location_index="location_index"
        @delete="$listeners['delete']"
      >
      </app-location-delete>
    </div>
  </tr>
</template>
<script>
export default {
  props: ["location", "location_index", "options"],
  methods: {
    emitChangeEvent(location_index, modal_id) {
      this.$emit("change-modal", {
        location_index: location_index,
        modal_id: modal_id,
      });
    },
    emitDeleteEvent(modal_id) {
      this.$emit("delete-modal", {
        modal_id: modal_id,
      });
    },
    mapTypeName(map_type) {
      return this.options.google_map[map_type];
    },
    statusName(status) {
      return this.options.status[status];
    },
  },
};
</script>
